import { render, staticRenderFns } from "./ListResellerPage.vue?vue&type=template&id=ad1f12cc&"
import script from "./ListResellerPage.vue?vue&type=script&lang=js&"
export * from "./ListResellerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports